import { render, staticRenderFns } from "./Sectores.vue?vue&type=template&id=b074fa2c&scoped=true&"
import script from "./Sectores.vue?vue&type=script&lang=js&"
export * from "./Sectores.vue?vue&type=script&lang=js&"
import style0 from "./Sectores.vue?vue&type=style&index=0&id=b074fa2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b074fa2c",
  null
  
)

export default component.exports